import { render, staticRenderFns } from "./ClassificationByIdView.vue?vue&type=template&id=30b4cc97&scoped=true"
import script from "./ClassificationByIdView.vue?vue&type=script&lang=js"
export * from "./ClassificationByIdView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b4cc97",
  null
  
)

export default component.exports